import { render, staticRenderFns } from "./TopNavi.vue?vue&type=template&id=67d774f5&scoped=true"
import script from "./TopNavi.vue?vue&type=script&lang=js"
export * from "./TopNavi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d774f5",
  null
  
)

export default component.exports